export const PAGE_TITLE = "Events";
export const PAGE_SINGLE_TITLE = "Event";
export const LINK_URL = "events";
export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  title: {
    type: "string",
    required: true,
    title: "Title",
    slug: true,
    inputType: "text",
  },
  content: {
    type: "html",
    required: false,
    title: "Content",
  },

  gallery: {
    type: "gallery",
    required: false,
    title: "Gallery",
  },
  meta_title: {
    type: "string",
    required: false,
    title: "Meta Title",
  },
  meta_description: {
    type: "text",
    required: false,
    title: "Meta Description",
  },
  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  title: "",
  content: "",
  slug: "",
  meta_title: "",
  meta_description: "",
};

export const view_all_table = [
  { name: "Title", value: "title" },
  { name: "Slug", value: "slug" },
];
